import React, { useEffect } from 'react'
import { LinkContainer } from 'react-router-bootstrap'
import { Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Message from '../components/Message'
import Loader from '../components/Loader'
import { listOrders } from '../actions/orderActions'

// Checkouts that never became orders: the customer reached the payment window
// and did not complete it. They are kept because an abandoned attempt is worth
// following up on, but they are not sales and must not be counted as such.
const DraftOrderListScreen = ({ history }) => {
  const dispatch = useDispatch()

  const orderList = useSelector((state) => state.orderList)
  const { loading, error, orders } = orderList

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  useEffect(() => {
    if (userInfo && userInfo.isAdmin) {
      dispatch(listOrders(true))
    } else {
      history.push('/login')
    }
  }, [dispatch, history, userInfo])

  const attempts = orders || []

  return (
    <div className='container minHeight100'>
      <h1 className='commonTitle--xl my-5'>Draft Orders</h1>
      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error}</Message>
      ) : attempts.length === 0 ? (
        <Message variant='info'>
          No abandoned checkouts. Every payment that was started was completed.
        </Message>
      ) : (
        <>
          <p className='text-muted mb-3'>
            {attempts.length} checkout{attempts.length === 1 ? ' was' : 's were'} started but never
            paid for. These have no order number and are not counted in sales.
          </p>
          <Table striped bordered hover responsive className='table-sm mb-5'>
            <thead>
              <tr>
                <th>Date</th>
                <th>Customer</th>
                <th>Phone</th>
                <th>TOTAL</th>
                <th>PAYMENT</th>
              </tr>
            </thead>
            <tbody>
              {attempts.map((order, i) => (
                <LinkContainer className='cursor-pointer' key={i} to={`/order/${order._id}`}>
                  <tr key={order?._id}>
                    <td>
                      {new Date(order.createdAt).toLocaleString('en-GB', {
                        day: 'numeric',
                        month: 'short',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true,
                      }).replace(',', ' at')}
                    </td>
                    <td>
                      {(order.user &&
                        [order.user.firstName, order.user.lastName].filter(Boolean).join(' ')) ||
                        '\u2014'}
                    </td>
                    <td>{(order.user && order.user.phone) || '\u2014'}</td>
                    <td>₹{order.totalPrice}</td>
                    <td>{order?.paymentStatus || 'Not attempted'}</td>
                  </tr>
                </LinkContainer>
              ))}
            </tbody>
          </Table>
        </>
      )}
    </div>
  )
}

export default DraftOrderListScreen
